import builder from '../builder';
import PasswordLock1 from '../../streamline-icons/light/password-lock-1.svg';

export default builder('IconPasswordLock1Light', PasswordLock1);
